<template>
  <v-form class="container" ref="form">
    <!-- Row 1: Mobile Number & Email -->
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Mobile Number *"
          v-model="contactInfo.mobileNumber"
          :rules="[mobileNumberRule]"
          variant="outlined"
          dense
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-phone</v-icon>
          </template>
        </v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field
          label="Email *"
          type="email"
          v-model="contactInfo.email"
          :rules="[emailRule]"
          variant="outlined"
          dense
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-email</v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <!-- Row 2: Linkedin Profile & P.O. Box -->
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          label="Linkedin Profile URL"
          v-model="contactInfo.linkedin"
          variant="outlined"
          dense
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="blue">mdi-linkedin</v-icon>
          </template>
        </v-text-field>
      </v-col>

      <v-col cols="12" sm="6">
        <v-text-field
          label="P.O. Box"
          v-model="contactInfo.poBox"
          variant="outlined"
          dense
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-post</v-icon>
          </template>
        </v-text-field>
      </v-col>
    </v-row>

    <!-- Row 3: Preferred Communication -->
    <v-row>
      <v-col cols="12" sm="6">
        <v-select
          label="Preferred Communication"
          :items="['Mobile', 'Email', 'Social Media']"
          v-model="contactInfo.preferredCommunication"
          variant="outlined"
          dense
          class="form-field"
          color="blue"
          hide-details="auto"
        >
          <template v-slot:prepend>
            <v-icon color="red">mdi-message</v-icon>
          </template>
        </v-select>
      </v-col>
    </v-row>

    <!-- Submit Button -->
    <!-- <v-btn color="primary" @click="validateAndSubmit">Submit</v-btn> -->

    <!-- Snackbar for validation messages -->
    <v-snackbar v-model="snackbar" :timeout="3000" top>
      {{ snackbarMessage }}
    </v-snackbar>
  </v-form>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      contactInfo: { ...this.formData }, // Initialize with the passed prop
      isValid: false,
      snackbar: false,
      snackbarMessage: "",
      mobileNumberRule: (value) => {
        const regex = /^(\+?\d{1,4})?\s?\d{10}$/;
        return regex.test(value) || "Enter a valid phone number";
      },
    
      emailRule: (value) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "Enter a valid email address",
    };
  },
  watch: {
    contactInfo: {
      handler(newData) {
        this.$emit("update-form-data", newData); // Emit the updated data back to parent
      },
      deep: true,
    },
  },

  computed: {
    userContact() {
      return this.$store.getters.user.contactInfo;
    },
  },
  mounted() {
    // Initialize personalInfo with the data from the computed property
    this.contactInfo = this.userContact? this.userContact:{};
  },
  methods: {
    reset() {
      this.contactInfo = {}; // Reset form data
    },
    // async validateAndSubmit() {
    //   const isValid = await this.$refs.form.validate();
    //   if (isValid) {
    //     this.snackbarMessage = "Form is valid!";
    //   } else {
    //     this.snackbarMessage = "Please fill in all required fields.";
    //   }
    //   this.snackbar = true;
    // },
    async validateForm() {
      const isValid = await this.$refs.form.validate();
      console.log('Form validation:', isValid);
      this.formIsValid = isValid.valid;
      console.log(isValid.valid ? 'All fields are valid.' : 'Validation failed.');
      return isValid.valid;   
      // return true;
    },
  },
};
</script>

  
  <style scoped>
  .stylish-field {
  background-color: #f9f9f9;
  padding: 8px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stylish-field:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 15px rgba(54, 202, 222, 0.4);
}

.country-select-field {
 

  border: 1px solid rgba(0, 0, 0, 0.397);
  border-radius: 3px;
  width: 100%;
  height: 40px;
  background: transparent;
  padding: 0;
  font-size: 1rem;
  color: #495057;
}



.container {
  max-width: 1000px;
  margin: 10px auto;
  padding: 10px;
  background: linear-gradient(135deg, #f0f4f8, #d9e2ec);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  border: 1px solid #e1e7ef;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  position: relative;
}

.container::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.2) 0%, transparent 70%);
  animation: rotate-bg 8s linear infinite;
  z-index: 0;
}

.container:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.container > * {
  position: relative;
  z-index: 1;
}

@keyframes rotate-bg {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.form-field {
  /* margin-bottom: 20px; */
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(231, 183, 179, 0.778);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.form-field:hover {
  transform: scale(1.02);
  box-shadow: 0 6px 15px rgba(109, 191, 46, 0.77);
}

.v-text-field input {
  font-size: 1rem;
  font-weight: 500;
}

.v-select .v-select__selections {
  font-size: 1rem;
  font-weight: 500;
}

.v-form .v-input__control {
  border-radius: 8px;
}

.v-text-field.v-text-field--outlined {
  background-color: #ffffff;
  border-radius: 12px;
}

.v-text-field .v-input__append-inner {
  padding-right: 15px;
}

.v-text-field .v-input__prepend-inner {
  padding-left: 15px;
}

.v-select {
  /* margin-top: 15px; */
}

.v-select .v-select__selections {
  font-size: 1rem;
  font-weight: 500;
}

.v-btn {
  background-color: #6200ea;
  color: white;
  padding: 12px 20px;
  border-radius: 50px;
  box-shadow: 0 4px 10px rgb(242, 12, 12);
  transition: background-color 0.3s ease;
}

.v-btn:hover {
  background-color: #3700b3;
} 

.red-icon {
  color: red !important;
}
  </style>
  